import actionTypes from "../../actions/actionTypes";

const initialState = {
  deleteCertificateLoader: false,
  uploadCertificateLoader: false,
  postNewCertificateLoader: false,
  postEditCertificateLoader: false,
};

const certificateManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.certificateManagementTypes
      .DELETE_CERTIFICATE_LOADER:
      return {
        ...state,
        deleteCertificateLoader: payload,
      };
    case actionTypes.adminTypes.certificateManagementTypes
      .UPLOAD_CERTIFICATE_LOADER:
      return {
        ...state,
        uploadCertificateLoader: payload,
      };
    case actionTypes.adminTypes.certificateManagementTypes
      .POST_NEW_CERTIFICATE_LOADER:
      return {
        ...state,
        postNewCertificateLoader: payload,
      };
    case actionTypes.adminTypes.certificateManagementTypes
      .POST_EDIT_CERTIFICATE_LOADER:
      return {
        ...state,
        postEditCertificateLoader: payload,
      };
    default:
      return state;
  }
};

export default certificateManagementReducer;
